import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import { getConfigChargerContact } from 'utils/clientHelper';

class ClientContactSelect extends React.Component {
    render() {
        const { value, onChangeClientContact, contacts, chargementExclu, chargerContactExclusionMotif } = this.props;

        let selected = value;
        if (contacts.length === 0 || chargementExclu) {
            selected = '';
        }

        const messageExclusion = chargementExclu
            ? getConfigChargerContact(chargerContactExclusionMotif).message
            : null;

        return (<TextField
            select
            name="contacts"
            label="Contacts"
            value={selected}
            onChange={onChangeClientContact}
            disabled={chargementExclu}
            helperText={messageExclusion}
            fullWidth>
            {contacts.length === 0 &&
                <MenuItem key="first" value={-1} disabled>
                    <em>Aucun contact prédéfini sur ce compte client</em>
                </MenuItem>
            }
            {contacts.length > 0 &&
                <MenuItem key="first" value={0}>
                    <em>Sélectionner un contact</em>
                </MenuItem>
            }
            {contacts.map(contact => (
                <MenuItem key={contact.id} value={contact.id}>
                    {contact.numero} {contact.nom} {contact.prenom} / {contact.email} / {contact.telephonePortable}
                </MenuItem>
            ))}
        </TextField>
        );
    }
}

ClientContactSelect.propTypes = {
    value: PropTypes.number.isRequired,
    contacts: PropTypes.array.isRequired,
    onChangeClientContact: PropTypes.func.isRequired,
    chargementExclu: PropTypes.bool,
    chargerContactExclusionMotif: PropTypes.number
};

export default ClientContactSelect;